// Campus photo for /colleges/university-of-minnesota-twin-cities: CC BY 2.0, by Chad Davis, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACyrus_Northrop_Memorial_Auditorium%2C_Minneapolis%2C_MN_(49062870376).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-minnesota-twin-cities/; credited under the photo.
const photo = {
    "slug": "university-of-minnesota-twin-cities",
    "alt": "Northrop Memorial Auditorium lit at night on the University of Minnesota campus in Minneapolis",
    "src": "/colleges/university-of-minnesota-twin-cities/campus-1600.webp",
    "srcSmall": "/colleges/university-of-minnesota-twin-cities/campus-800.webp",
    "srcMid": "/colleges/university-of-minnesota-twin-cities/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-minnesota-twin-cities/og.jpg",
    "title": "Cyrus Northrop Memorial Auditorium, Minneapolis, MN (49062870376)",
    "author": "Chad Davis",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACyrus_Northrop_Memorial_Auditorium%2C_Minneapolis%2C_MN_(49062870376).jpg",
    "read": "2026-10-02"
};

export default photo;
